import { SpinnerComponent } from './Spinner.types';
import { CircularLoader, LoaderIconWrapper, LoaderPath, LoaderWrapper } from './Spinner.styles';

export const Spinner: SpinnerComponent = ({ strokeWidth = '3px', dataTestId }) => (
  <LoaderWrapper
    container
    item
    flex="1 1 auto"
    alignItems="center"
    justifyContent="center"
    direction="column"
    data-testid={dataTestId}
  >
    <LoaderIconWrapper>
      <CircularLoader viewBox="25 25 50 50">
        <LoaderPath cx="50" cy="50" r="20" fill="none" stroke="#70c542" strokeWidth={strokeWidth} />
      </CircularLoader>
    </LoaderIconWrapper>
  </LoaderWrapper>
);
